import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import lbx_panel_bg from '../assets/lbx_panel_bg.png';
import drug_combination_center_image from '../assets/drug_combination_center_image.png';
import LanternLabs3 from '../assets/LanternLabs3.png';
import './drugcombination_DetailPanel.css';
import PanelNavbar from './PanelNavbar';

const DrugCombinationDetailPanel = ({ isOpen, onClose, sectionData }) => {
    const nextSectionRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            if (contentRef.current) {
                contentRef.current.scrollTop = 0;
            }
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    const scrollToNextSection = () => {
        if (nextSectionRef.current && contentRef.current) {
            const yOffset = -100; // Offset to show the section clearly
            const container = contentRef.current;
            const element = nextSectionRef.current;
            const containerY = element.offsetTop + yOffset;
            container.scrollTo({ top: containerY, behavior: 'smooth' });
        }
    };

    return (
        <div className={`detail-panel-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div
                ref={contentRef}
                className={`detail-panel-content ${isOpen ? 'open' : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <PanelNavbar onClose={onClose} logo="" />
                <div className="panel-container">
                    <div
                        className="panel-hero-bg"
                        style={{
                            backgroundImage: `url(${lbx_panel_bg})`,
                        }}
                    ></div>
                    <div className="panel-body">
                        <h1 className="panel-main-title">Predict the efficacy of complex cancer drug combinations</h1>
                        <p className="panel-description-text">
                            Designing combination regimens with DNA-damaging agents or DDR inhibitors? Our module forecasts activity, safety, and biomarker-driven response using one of the most comprehensive clinical datasets in the field.
                        </p>
                        <button className="panel-try-btn" onClick={scrollToNextSection}>
                            <span className="panel-try-btn-text">Explore the module</span>
                        </button>
                    </div>
                    <div className="panel-center-image-container">
                        <img
                            src={drug_combination_center_image}
                            alt="Drug Combination Analysis"
                            className="panel-center-image"
                        />
                    </div>

                    <div className="panel-next-section" ref={nextSectionRef}>
                        <div className="section-title-group">
                            <h2 className="section-title-large">Evidence-driven insights for smarter combination therapy design</h2>
                            <div className="accuracy-label-container">
                                <div className="accuracy-line"></div>
                                <div className="accuracy-ellipse"></div>
                                <span className="accuracy-text"></span>
                            </div>
                        </div>

                        <div className="section-description-rich">
                            <p>
                                <span className="text-italic-medium">Combination module</span>
                                <span> I is Lantern Labs’ AI module trained on 221 clinical trials involving DNA-damaging agents and DNA damage response inhibitors. By integrating genomic, transcriptomic, and clinical data, the platform predicts synergistic interactions, identifies biomarker-defined responders, and highlights potential safety considerations.With its data-driven models and proven real-world impact, including guiding an FDA-cleared Phase 1B/2 trial, Combo-AI empowers researchers to design combination regimens with </span>
                                <span className="text-medium">greater accuracy</span>
                                <span>, </span>
                                <span className="text-medium">reduced risk</span>
                                <span>, and </span>
                                <span className="text-medium">clearer therapeutic rationale.</span>
                            </p>
                        </div>
                    </div>

                    <div className="panel-demo-section">
                        {/* Decorative Background Elements */}
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-1" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-2" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-3" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-4" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-5" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-6" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-7" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-8" />

                        <div className="demo-content-wrapper">
                            <div className="demo-text-box">
                                <h2 className="demo-title">
                                    <span className="demo-title-light">See how our module identify synergy, biomarkers, and clinical trajectories across  </span>
                                    <span className="demo-title-medium">DDA + DDR inhibitor combinations.</span>
                                    <br />
                                </h2>
                            </div>

                            <div className="demo-symbol-container">
                                <div className="demo-vertical-line"></div>
                                <div className="demo-symbol-ellipse"></div>
                                <Link
                                    to="/contact"
                                    className="demo-try-btn"
                                    style={{
                                        textDecoration: 'none',
                                        position: 'relative',
                                        left: 'unset',
                                        top: 'unset',
                                        transform: 'unset',
                                        marginTop: '50px'
                                    }}
                                >
                                    <span className="demo-try-btn-text">Contact us</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DrugCombinationDetailPanel;

